import Money from '@square/dashboard-money/models/money';
export default {
  // Converts squareup.connect.v2.common.Money to squareup.common.Money
  // { amount: 2400, currency: 'USD' } --> { amount: 2400, currencyCode: 'USD' }
  deserialize(connectMoney) {
    if (connectMoney !== null && connectMoney !== undefined) {
      return Money.create({
        amount: connectMoney.amount ?? 0,
        currencyCode: connectMoney.currency
      });
    }
    return undefined;
  },
  // Converts squareup.common.Money to squareup.connect.v2.common.Money
  // { amount: 2400, currencyCode: 'USD' } --> { amount: 2400, currency: 'USD' }
  serialize(money) {
    if (money !== null && money !== undefined) {
      const {
        amount,
        currencyCode
      } = money;
      return {
        amount,
        currency: currencyCode
      };
    }
    return undefined;
  }
};